import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import PasswordResetInit from 'app/modules/account/password-reset/init/password-reset-init';
import TransactionListPage from './transaction';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId`} component={TransactionListPage} />
    </Switch>
  </>
);

export default Routes;
